import { create } from "zustand";

interface ProgressState {
    progress: number,
    updateProgress: ( value: number) => void,
    resetProgress: () => void
}

export const useProgressStore = create<ProgressState>((set) => ({
    progress: 0,
    updateProgress: (value) => {
        set({
            progress: value
        })
    },
    resetProgress: () => {
        set({
            progress: 0
        })
    }
}))